import React, { useEffect, useState } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import {
  addeditdata,
  chnageStatus,
} from "../../../controllers/investorsUsers/investorUsersController";
import { list as firmList } from "../../../controllers/investors/investorController";
import { fetchIpAddress } from "../../../controllers/API";

import LoadingEffect from "../../../components/Loading/LoadingEffect";
import { beforeUpload } from "../../../controllers/common";

const UserListEditPage = () => {
  const { Option } = Select;
  const { Dragger } = Upload;

  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const listQuery = state?.listQuery;
  const investorUserData =
    state?.item !== undefined
      ? state.item
      : state && !state.listQuery
      ? state
      : {};
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(investorUserData);
  const [image, setImage] = useState([]);
  const [firmsList, setFirmList] = useState([]);
  // const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({});

  const getFirmsList = async () => {
    try {
      setFirmList([]);
      const options = {
        type: "",
        condition: { status: "A" },
        select: {},
        sort: { investor_firm_name: 1 },
        skip: 0,
        limit: 0,
      };
      const listData = await firmList(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setFirmList(listData?.result);
        } else {
          setFirmList([]);
        }
      } else {
        setFirmList([]);
      }
    } catch (error) {
      console.log("error", error);
      setFirmList([]);
    }
  }; //End

  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  // const handleChange = (e) => {
  //   setAddEditSata((pre) => ({
  //     ...pre,
  //     [e.target.name]: e.target.value,
  //   }));
  //   setError((pre) => ({
  //     ...pre,
  //     [e.target.name]: "",
  //   }));
  // };
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "firm") {
      setAddEditSata((pre) => ({
        ...pre,
        [name]: JSON.parse(value),
      }));
    } else {
      setAddEditSata((pre) => ({
        ...pre,
        [e.target.name]: e.target.value,
      }));
    }
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };
  /*********************************************************
   *  This function is use to handle image
   *********************************************************/
  const handleImageChnage = (e) => {
    setImage(e.fileList);
  };
  /*********************************************************
   *  This function is use to handle genger checkbox chnage
   *********************************************************/
  const onCheckedChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      vendor_gender: e.target.value,
    }));
  };

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const {
        _id,
        investor_first_name,
        investor_last_name,
        investor_email,
        investor_phone,
        investor_designation,
        firm,
        // investor_description,
        cc_accounts,
        investor_priority,
        investor_max_meet,
        investor_from_time,
        investor_to_time
      } = ADDEDITDATA;
      const ipAddress = await fetchIpAddress();

      const form = new FormData();
      if (_id && _id !== "undefined" && _id !== null) {
        form.append("edit_id", _id);
      }
      form.append("first_name", investor_first_name ? investor_first_name : "");
      form.append("last_name", investor_last_name ? investor_last_name : "");
      form.append("email", investor_email ? investor_email : "");
      form.append("phone", investor_phone ? investor_phone : null);
      form.append(
        "designation",
        investor_designation ? investor_designation : ""
      );
      form.append("firm", firm ? firm?._id : "");
      form.append("cc_accounts", cc_accounts ? cc_accounts : "");
      form.append(
        "investor_priority",
        investor_priority ? investor_priority : ""
      );
      form.append("investor_max_meet", investor_max_meet ? investor_max_meet : "");
      form.append("investor_from_time", investor_from_time ? investor_from_time : "");
      form.append("investor_to_time", investor_to_time ? investor_to_time : "");
      form.append("ipAddress", ipAddress);

      const isValidate = validateFormData(form);

      if (isValidate) {
        const options = {
          url: "accounts/investor-user/addeditdata",
          postData: form,
        };
        const res = await addeditdata(options);
        if (res.status === true) {
          notification.open({
            message: "Data updated!",
            description: `Data updated successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/investor-user/list", { state: { listQuery } });
        } else {
          notification.open({
            message: "Opps!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Opps!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  /*********************************************************
   *  This function is used to validate form data before submit
   *********************************************************/
  const validateFormData = (formData) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const numberPattern = /^[6-9][0-9]{9}$/;
    const name = /^[A-Za-z\s]+$/;
    // const vendor_country_code = formData.get("country_code");

    if (
      !formData.get("first_name")?.trim() ||
      formData.get("first_name") === "" ||
      formData.get("first_name") === "undefined"
    ) {
      setError((prevError) => ({
        ...prevError,
        investor_first_name: "First name is required",
      }));
      return false;
    }
    if (!name.test(formData.get("first_name"))) {
      setError((prevError) => ({
        ...prevError,
        investor_first_name: "Please enter a valid name",
      }));
      return false;
    }
    const myLastname = formData.get("last_name");
    if (myLastname) {
      if (!name.test(myLastname)) {
        setError((prevError) => ({
          ...prevError,
          investor_last_name: "Please enter a valid name",
        }));
        return false;
      }
    }
    if (
      !formData.get("email")?.trim() ||
      formData.get("email") === "" ||
      formData.get("email") === "undefined"
    ) {
      setError((prevError) => ({
        ...prevError,
        investor_email: "Email address is required",
      }));
      return false;
    }
    if (!emailPattern.test(formData.get("email"))) {
      setError((prevError) => ({
        ...prevError,
        investor_email: "Please enter a valid email address",
      }));
      return false;
    }

    if (
      !formData.get("firm")?.trim() ||
      formData.get("firm") === "" ||
      formData.get("firm") === "undefined"
    ) {
      setError((prevError) => ({
        ...prevError,
        firm: "Please select firm",
      }));
      return false;
    }

    // const myPhone = formData.get("phone");
    // if(myPhone != '' || myPhone != null || myPhone != 'undefined'){
    //   if(!numberPattern.test(myPhone)){
    //     setError((prevError) => ({
    //       ...prevError,
    //       investor_phone: "Invalid phone",
    //     }));
    //     return false;
    //   }
    // }

    // const myFirmname = formData.get("firm_name");
    // if(myFirmname){
    //   if(!companyname.test(formData.get("firm_name"))){
    //     setError((prevError) => ({
    //       ...prevError,
    //       investor_firm_name: "Please enter a valid firm name",
    //     }));
    //     return false;
    //   }
    // }

    // const mydesignation = formData.get("designation");
    // if(mydesignation){
    //   if(!name.test(mydesignation)){
    //     setError((prevError) => ({
    //       ...prevError,
    //       investor_designation: "Please enter a valid designation",
    //     }));
    //     return false;
    //   }
    // }

    // if (!ADDEDITDATA?._id) {
    //   if (!formData.get("image")) {
    //     setError((prevError) => ({
    //       ...prevError,
    //       image: "Image is required",
    //     }));
    //     return false;
    //   }
    // }
    return true;
  };

  /*********************************************************
   *  This function is use to handle delete account
   *********************************************************/
  const handleDelete = async () => {
    try {
      const options = {
        url: `accounts/investors/changestatus`,
        postData: {
          user_id: ADDEDITDATA?._id,
          status: "D",
        },
      };
      const res = await chnageStatus(options);
      if (res.status === true) {
        notification.open({
          message: "User deleted successfully.",
          description: `Data delete successfully.`,
          placement: "topRight",
          icon: <CheckCircleOutlined style={{ color: "green" }} />,
          duration: 2,
        });
        navigate("/users/list");
      } else {
        notification.open({
          message: "Opps!",
          description: `${res?.message}`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      notification.open({
        message: "Opps!",
        description: `Operation not perform yet! please try in some time.`,
        placement: "topRight",
        icon: <InfoCircleOutlined style={{ color: "red" }} />,
        duration: 2,
      });
    }
  };

  useEffect(() => {
    getFirmsList();
    document.title = "Chiratae Super Admin || Investors List";
  }, []);

  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <div>
            <h5 className="inventory_edit_page_heading">
              {ADDEDITDATA?._id ? `Edit` : `Add`} Investors
            </h5>
          </div>
          <Link to="/investor-user/list" state={{ listQuery }}>
            <div>
              <button type="button" className="btn btn-secondary">
                <ArrowLeftOutlined /> Back
              </button>
            </div>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet">
                <div className="row inventory_form_main_content_form_section">
                  <div className="row">
                    <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="vendor_first_name"
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>First Name :{" "}
                      </label>
                      <input
                        title="First Name"
                        placeholder="Enter first name"
                        type="text"
                        name="investor_first_name"
                        className="form-control store_input_field"
                        id="investor_first_name"
                        value={ADDEDITDATA?.investor_first_name}
                        onChange={handleChange}
                      />
                      {error.investor_first_name ? (
                        <p style={{ color: "red" }}>
                          {error.investor_first_name}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="investor_last_name"
                        className="all_section_for_label_main_class"
                      >
                        Last Name :{" "}
                      </label>
                      <input
                        title="Enter last name."
                        placeholder="Enter last name."
                        type="text"
                        name="investor_last_name"
                        className="form-control store_input_field"
                        id="investor_last_name"
                        value={ADDEDITDATA?.investor_last_name}
                        onChange={handleChange}
                      />
                      {error.investor_last_name ? (
                        <p style={{ color: "red" }}>
                          {error.investor_last_name}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="investor_email"
                        className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Email Address :
                      </label>
                      <input
                        title="Enter email address."
                        placeholder="Enter email address."
                        type="text"
                        name="investor_email"
                        className="form-control store_input_field"
                        id="investor_email"
                        value={ADDEDITDATA?.investor_email}
                        onChange={handleChange}
                      />
                      {error.investor_email ? (
                        <p style={{ color: "red" }}>{error.investor_email}</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="investor_phone"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        Phone :
                      </label>
                      <input
                        title="Enter Phone no."
                        placeholder="Enter Phone no."
                        type="number"
                        name="investor_phone"
                        className="form-control store_input_field"
                        id="investor_phone"
                        value={ADDEDITDATA?.investor_phone}
                        onChange={handleChange}
                      />
                      {error.investor_phone ? (
                        <p style={{ color: "red" }}>{error.investor_phone}</p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {/* <hr /> */}
                  <div className="row">
                    <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="investor_firm"
                        className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                      >
                      <span style={{ color: "red" }}>*</span>Select Firm :
                      </label>
                      <select
                        className="form-control"
                        name="firm"
                        id="firm"
                        onChange={handleChange}
                        style={{fontSize:"13px"}}
                      >
                        <option value="">Select Firm</option>
                        {firmsList.map((firms, index) => (
                          <option
                            value={JSON.stringify(firms)}
                            selected={firms?._id === ADDEDITDATA?.firm?._id}
                            key={index}
                          >
                            {firms.investor_firm_name}
                          </option>
                        ))}
                      </select>
                      {error.firm ? (
                        <p style={{ color: "red" }}>{error.firm}</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="investor_designation"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        Designation :
                      </label>
                      <input
                        title="Enter designation"
                        placeholder="Enter designation"
                        type="text"
                        name="investor_designation"
                        className="form-control store_input_field"
                        id="investor_designation"
                        value={ADDEDITDATA?.investor_designation}
                        onChange={handleChange}
                      />
                      {error.investor_designation ? (
                        <p style={{ color: "red" }}>
                          {error.investor_designation}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-group col-lg-12 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="cc_accounts"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        CC Accounts :
                      </label>
                      <input
                        title="Enter cc accounts"
                        placeholder="Enter cc accounts"
                        type="text"
                        name="cc_accounts"
                        className="form-control store_input_field"
                        id="cc_accounts"
                        value={ADDEDITDATA?.cc_accounts}
                        onChange={handleChange}
                      />
                      {error.cc_accounts ? (
                        <p style={{ color: "red" }}>{error.cc_accounts}</p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <hr/>
                  <h4>Meeting Configuration Details</h4>
                  <div className="row">
                    <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="investor_priority"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        Investor priority :
                      </label>
                      <input
                        title="Enter investor priority"
                        placeholder="Enter investor priority"
                        type="number"
                        name="investor_priority"
                        className="form-control store_input_field"
                        id="investor_priority"
                        value={ADDEDITDATA?.investor_priority}
                        onChange={handleChange}
                      />
                      {error.investor_priority ? (
                        <p style={{ color: "red" }}>
                          {error.investor_priority}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="investor_max_meet"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        Max Meet Cap :
                      </label>
                      <input
                        title="Enter max meet cap"
                        placeholder="Enter max meet cap"
                        type="number"
                        name="investor_max_meet"
                        className="form-control store_input_field"
                        id="investor_max_meet"
                        value={ADDEDITDATA?.investor_max_meet}
                        onChange={handleChange}
                      />
                      {error.investor_max_meet ? (
                        <p style={{ color: "red" }}>
                          {error.investor_max_meet}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="investor_from_time"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        Investor From time :
                      </label>
                      <input
                        title="Enter investor from time"
                        placeholder="Enter investor from time"
                        type="time"
                        name="investor_from_time"
                        className="form-control store_input_field"
                        id="investor_from_time"
                        value={ADDEDITDATA?.investor_from_time}
                        onChange={handleChange}
                      />
                      {error.investor_from_time ? (
                        <p style={{ color: "red" }}>
                          {error.investor_from_time}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="investor_to_time"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        Investor to time :
                      </label>
                      <input
                        title="Enter investor to time"
                        placeholder="Enter investor to time"
                        type="time"
                        name="investor_to_time"
                        className="form-control store_input_field"
                        id="investor_to_time"
                        value={ADDEDITDATA?.investor_to_time}
                        onChange={handleChange}
                      />
                      {error.investor_to_time ? (
                        <p style={{ color: "red" }}>
                          {error.investor_to_time}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>

                <div className="inventory_edit_submit_btn">
                  <button
                    type="button"
                    className="btn btn-primary inventory_save_button"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <LoadingEffect isLoading={isLoading} /> */}
    </div>
  );
};

export default UserListEditPage;
